import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Form, Label, Input, Button } from '../Form';
import { api, setToken } from '../../utils/api';
import withTranslations from '../../utils/translations/withTranslations';

import './Login.css';

class Login extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true,
      isBusy: false,
      error: false
    };
  }

  login(credentials) {
    const { history, translate } = this.props;
    this.setState({ isBusy: true });

    api
      .post('/auth/login', credentials)
      .then(({ data }) => {
        // Store the token in localStorage
        setToken(data.access_token);

        // Go to /
        history.push('/');
      })
      .catch(data => {
        const error =
          (data && data.data && translate(`login.${data.data.error}`)) ||
          'Something went wrong.';

        this.passwordField.value = '';
        this.passwordField.focus();

        this.setState({ isBusy: false, error: error });
      });
  }

  render() {
    const { isValid, error, isBusy } = this.state;
    const { translate } = this.props;

    return (
      <div>
        {error !== false && <div className="Login__Error">{error}</div>}

        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          onSubmit={data => this.login(data)}
        >
          <Label text={translate('login.email')} />
          <Input rules={['required', 'email']} name="email" />

          <Label text={translate('login.password')} />
          <Input
            type="password"
            rules={['required']}
            name="password"
            inputRef={input => (this.passwordField = input)}
          />

          <div className="Login__Form__Button">
            <Button
              disabled={!isValid || isBusy}
              solid
              className="Login__Button"
            >
              {translate('login.login')}
            </Button>
          </div>
          <Link to="/wachtwoord/email">
            {translate('login.password_forgot')}
          </Link>
        </Form>
      </div>
    );
  }
}

export default withRouter(withTranslations(Login));
